import { createReducer, createStandardAction } from "typesafe-actions";
import { datadogLogs } from "@datadog/browser-logs";
import { uniq } from "lodash";

export const addKnownPattern = createStandardAction("KNOWN_ROUTE_PATTERN")<
  string | Array<string>
>();

export interface RouteState {
  paths: Array<string>;
}

//Try and start with known ones to improve accuracy;
const insightsPaths = [
  "/insights/details/:id",
  "/insights/details/:id/devices/:deviceId",
  "/insights/details/:id/devices"
];

const managementPaths = [
  "/manage/inventory/details/:deviceId",
  "/manage/inventory/details/:deviceId/delete",
  "/manage/inventory/details/:deviceId/edit",
  "/manage/inventory/details/:deviceId/settings",
  "/manage/inventory/details/:deviceId/settings/basic",
  "/manage/inventory/details/:deviceId/settings/advanced",
  "/manage/sites/details/:siteId",
  "/manage/sites/details/:siteId/add",
  "/manage/sites/details/:siteId/settings/general",
  "/manage/sites/details/:siteId/settings/provisioning",
  "/manage/sites/details/:siteId/instructions",
  "/manage/rooms/details/:roomId",
  "/manage/rooms/details/:roomId/settings/general",
  "/manage/rooms/details/:roomId/instructions",
  "/manage/members/details/:user_id",
  "/manage/members/details/:user_id/edit"
];

const adminPaths = [
  "/admin/accounts/:accountId",
  "/admin/accounts/details/:id",
  "/admin/accounts/details/:id/edit"
];

export const defaultRouteState: RouteState = {
  paths: [...insightsPaths, ...managementPaths, ...adminPaths]
};

export const addRoute = (
  state: RouteState,
  { payload }: { payload: string | Array<string> }
): RouteState => {
  let updates: string[];
  if (Array.isArray(payload)) {
    updates = payload;
  } else {
    updates = [payload];
  }
  const hasPathParam = updates.filter(it => it.includes(":"));
  const newOnes = updates.filter(x => !state.paths.includes(x));
  const anyAreNew = newOnes.length > 0;
  if (hasPathParam.length > 0 && anyAreNew) {
    const updated = uniq([...hasPathParam, ...state.paths]);
    datadogLogs.logger.warn(
      "Found missing route configs, please add the following to routes.ts",
      { missingEntries: newOnes }
    );
    return {
      paths: updated
    };
  }
  return state;
};

export const RouteReducer = createReducer(defaultRouteState).handleAction(
  addKnownPattern,
  addRoute
);
